<mat-toolbar class="header" style="background-color: #FFFFFF;" #header>
  <div style="width: 100%; display: flex; align-items: center; justify-content: space-between; height: 100%; cursor: pointer;" >
    <div class="header__title">
      <!--<button class="header__title-button" mat-mini-fab (click)="openMenu()" color="primary" #headerTile>
        <mat-icon *ngIf="!isMenuOpened" class="header__title-button-icon">menu</mat-icon>
        <mat-icon *ngIf="isMenuOpened" class="header__title-button-icon">menu</mat-icon>
      </button>-->
      <h1 *ngIf="logoUrl" class="app-workforce">
        <a style="text-decoration-line: none; display: flex; align-items: center; justify-content: center;" (click)="managementPanel()">
          <img class="logo" [src]="logoUrl" alt="company" style="max-width: 130px; max-height: 70px;">
        </a>
      </h1>
    </div>

    <div style="width:100%; display:flex; justify-content:center; height:100%;">
    </div>
    <div class="header-toolbar" style="height:100%;">
      <!--<mat-form-field *ngIf="_appsService.isAdmin" style="margin-left:10px; width:125px;margin-right:10px; ">
    <mat-select #searchCompany style="font-size: 15px;" [(value)]="_appsService.selectedCompany" (selectionChange)="layout.onSelectedCompany($event.value)">
      <input id="search" placeholder="Arama" (keyup)="onKey($event.target.value)">
      <mat-option *ngFor="let company of _appsService.filterCompanies" [value]="company.id">
        {{company.companyName}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field >
    <mat-select style="font-size: 15px;" [(value)]="_appsService.selectedProject" (selectionChange)="layout.onSelectedProject($event.value)">
      <mat-option *ngFor="let project of _appsService.projects" [value]="project.projectId">
        <span [ngClass]="project.parentId ? 'child-project':'parent-project'">{{project.projectName}}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>-->


      
      <!--<div class="row" style="height: 100%; display: flex; justify-content: center; align-items: center; margin-right:15px; font-weight:300;">
        <button mat-button class="centered-button" style="display: flex; align-items: center; padding: 8px 16px; font-size: 14px; font-weight: 500;">
          <img src="../../../../assets/icons/help.png" alt="help" class="centered-image" style="width: 24px; height: 24px; vertical-align: middle; margin-right: 8px;">
          <span style="line-height: 1;">{{'help' | translate}}</span>
        </button>
      </div>-->

      <!-- Tutorial Menu -->
      <app-tutorial-menu></app-tutorial-menu>

      <app-notifications ></app-notifications>

      <h1 *ngIf="!mobileQuery.matches" style="margin-right:10px;margin-left:10px;"></h1>
      <app-user (signOut)="signOut()" (profileStatus)="getCurrentStatus($event)"></app-user>
    </div>
  </div>

</mat-toolbar>



